<template>
  <div>

    <div class="c-results" v-if="count > 0">
      <h3>{{count}}&nbsp;Audi</h3>
      <div class="c-results-row">
        <div class="c-results-item" v-for="offer in offers">
          <a :href="offer.url_full" class="c-results-item-details" target="_blank" title="Zobacz szczegóły modelu"></a>
          <div class="c-results-item-img background-box" :style="{ 'background-image': 'url(' + offer.photo_url + ')'}">
            <!-- <img v-bind:src="offer.photo_url" alt=""> -->
          </div>
          <div class="c-results-item-head">
            <h2>{{offer.brand_name}} {{offer.model_name}}</h2>
            <h3>{{offer.title}}</h3>
          </div>
          <div class="c-results-item-price">
            <strong>{{formatPrice.to(parseInt(offer.price))}}</strong>
          </div>
          <div class="c-results-item-params">
            <p>
              <strong>Moc maksymalna:</strong>&nbsp;<span>{{offer.power}} KM</span>
            </p>
            <p>
              <strong>Rodzaj paliwa:</strong>&nbsp;<span v-for="e in Fueltype" v-if="e.id == offer.fuel_id">{{e.name}}</span>
            </p>
            <p>
              <strong>Rodzaj napędu:</strong>&nbsp;<span>{{offer.drive}}</span>
            </p>
            <p>
              <strong>Typ nadwozia:</strong>&nbsp;<span>{{offer.body}}</span>
            </p>
          </div>
          <!-- <a :href="'/public/print_details.php?number='+offer.id"> -->
            <div v-on:click="showForm(offer.id)" class="c-results-item-more">
              <p>Szczegóły</p>
            </div>
          <!-- </a> -->
          <div v-on:click="scrolltoForm(offer.offer_number)" class="c-results-item-more">
            <p>Zapytaj o ofertę</p>
          </div>
        </div>
      </div>
    </div>
    <div class="c-results" v-else-if="count == 0">
      <h3>Nie znalazłeś swojego samochodu?<br />Znajdziemy go dla Ciebie.</h3>
      <a href="#c-formhtml">
        <h3 class="c-results-button"><span>>></span> Skorzystaj z formularza </h3>
      </a>

    </div>
    <div id="c-formhtml" class="c-formhtml">
      <h2>Formularz kontaktowy</h2>
      <h5>
        Jeżeli chcesz otrzymać ofertę na wybrany samochód, wypełnij i wyślij formularz kontaktowy. Zadzwonimy do Ciebie, aby przygotować indywidualną ofertę.
      </h5>
      <div v-html="formHtml">
      </div>
    </div>
  </div>

</template>

<script>
import wNumb from 'wnumb'

export default {
  name: 'Results',
  props: [
    'ModelList',
    'Fueltype',
    'Geartype',
    'Transmissiontype',
    'Price',
    'ModelCount'
  ],
  data: function () {
    return {
      offers: '',
      page: 1,
      pages: 0,
      limit: 999,
      model: Array(),
      formatPrice: wNumb({ decimals: 0, prefix: '', suffix: ' PLN', thousand: ' ' }),
      count: String,
      formUrl: 'http://audisosnowiec.pl/include/formularz-wyszukiwarka-samochodow-nowych.php',
      formHtml: '...'
    }
  },
  methods: {
    scrolltoForm: function (numer) {
      var elmnt = document.getElementById("c-formhtml");
      elmnt.scrollIntoView();
    },
    getForm: function () {
      this.axios.get(this.formUrl).then((response) => {
        this.formHtml = response.data
      })
    },
    getModels: function getModels () {
      var params = 'ty2'
      if (this.Price.from.value) {
        params += 'pf' + this.Price.from.value + ','
      }
      if (this.Price.to.value) {
        params += 'pt' + this.Price.to.value + ','
      }
      if (this.Geartype != null) {
        var paramsTemp = ''
        var cnt = 0
        for (var key in this.Geartype) {
          if (this.Geartype[key].selected == true) {
            paramsTemp += 'ti' + this.Geartype[key].id + ','
            cnt++
          }
        }
        var pos = paramsTemp.lastIndexOf(',')
        params += paramsTemp.substring(0, pos) + '' + paramsTemp.substring(pos + 1)
        if (cnt > 0) {
          params += ','
        }
      }
      if (this.Fueltype != null) {
        var paramsTemp = ''
        var cnt = 0
        for (var key in this.Fueltype) {
          if (this.Fueltype[key].selected == true) {
            paramsTemp += 'fi' + this.Fueltype[key].id + ','
            cnt++
          }
        }
        var pos = paramsTemp.lastIndexOf(',')
        params += paramsTemp.substring(0, pos) + '' + paramsTemp.substring(pos + 1)
        if (cnt > 0) {
          params += ','
        }
      }
      if (this.Transmissiontype != null) {
        var paramsTemp = ''
        var cnt = 0
        for (var key in this.Transmissiontype) {
          if (this.Transmissiontype[key].selected == true) {
            paramsTemp += 'dn' + this.Transmissiontype[key].id + ','
            cnt++
          }
        }
        var pos = paramsTemp.lastIndexOf(',')
        params += paramsTemp.substring(0, pos) + '' + paramsTemp.substring(pos + 1)
        if (cnt > 0) {
          params += ','
        }
      }
      // params += 'c-sosnowiec'
      params += 'ty2,yf2018,yt2018,c-sosnowiec'
      this.model = ''
      for (var key in this.ModelList) {
        if (this.ModelList[key].selected == true) {
          this.model += this.ModelList[key].url + ','
        }
      }
      var _this = this
      this.axios.get('https://webapi.piamarket.pl/list2', {
        params: {
          url_brand: 'audi',
          url_model: this.model.replace(/,\s*$/, ''),
          url_params: params,
          limit: this.limit,
          page_number: this.page,
          order: 0,
          lat: 0,
          lng: 0
        }
      }).then(function (response) {
        _this.offers = response.data.cars
        if (response.data.count / _this.limit > 0 && response.data.count / _this.limit < 1) {
          _this.pages = 1
        } else {
          _this.pages = Math.round(response.data.count / _this.limit)
        }
        _this.count = response.data.count
        _this.$emit('ModelCount', response.data.count)
      }).catch(function (error) {
        window.alert(error)
      })
    },
    showForm: function (number) {
      if (!number) {
        this.$emit('ShowForm', true)
      }else{
        this.$emit('ShowForm', true)
        this.$emit('NumberOffer', number)
      }
      console.log(number);

    },
  },
  watch: {
    ModelList: {
      handler: function () {
        this.page = 1
        this.getModels()
      },
      deep: true
    },
    Fueltype: {
      handler: function () {
        this.page = 1
        this.getModels()
      },
      deep: true
    },
    Geartype: {
      handler: function () {
        this.page = 1
        this.getModels()
      },
      deep: true
    },
    Transmissiontype: {
      handler: function () {
        this.page = 1
        this.getModels()
      },
      deep: true
    },
    Price: {
      handler: function () {
        this.page = 1
        this.getModels()
      },
      deep: true
    }
  },
  created: function () {
    this.page = 1
    this.getModels()
  },
  mounted: function () {
    this.getForm()
  }
}
</script>
<style lang="scss">
.c-formhtml {
  margin: 0 auto;
  max-width: 1177.6px;
  width: 92%;
}
.c-results{
  margin: 0 auto;
  max-width: 1177.6px;
  width: 92%;
  padding:2rem 0 0 0;
  &-row{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    border-top: 1px solid #b3b3b3;
  }
  &-item{
    position: relative;
    width: calc(100% * (1/4));
    max-width: calc(100% * (1/4) - 30px);
    // @media(max-width: 1000px){
    //   width: calc(100% * (1/3));
    //   max-width: calc(100% * (1/3) - 30px);
    // }
    @media(max-width: 960px){
      width: calc(100% * (1/2));
      max-width: calc(100% * (1/2) - 30px);
    }
    @media(max-width: 780px){
      width: calc(100% * (1/1));
      max-width: calc(100% * (1/1) - 30px);
    }
    flex-grow: 1;
    margin: 15px 30px 15px 0px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    border-bottom: 1px solid #d5d5d5;
    &-img{
      height: 160px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      img{
        width: 100%;
      }
    }
    &-head{
      h2{
        margin: 0;
      }
      h3{
        font-weight: normal;
        font-size: 1rem;
        margin: .5rem 0;
      }
    }
    &-price{
      strong{
        font-size: 1rem;
        margin: .5rem 0;
      }
    }
    &-params{

    }
    &-more {
      margin-bottom: 5px;
      cursor: pointer;
      background: #c03;
      padding: 1px;
      text-align: center;
      color: #fff;
      font-weight: bold;
      &:hover {
        background: #af022d;
      }
    }
    &-details{
      position: absolute;
      top:0;
      right: 0;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.7) url('../assets/images/eye.png') no-repeat center;
      background-size: 60%;
      display: block;
      z-index: 999;
    }
  }
  &-button{
    background-color: #000;
    padding: 1rem;
    color: #fff;
    display: inline-block;
    cursor: pointer;
    span{
      color: #c03;
    }
  }
}
</style>
